angular.module('env.data.repos.categoryTypes', [])

    .service("categoryTypesRepository", function (rest) {
        var _this = this;
        var categoryTypeModel = "CategoryTypeModel";
        var categoryModel = "CategoryModel";
        var categoryTypeDefinition = rest.getDefinition(categoryTypeModel);
        var categoryDefinition = rest.getDefinition(categoryModel);

        /**
         * Get all CategoryTypes
         * @returns {!Promise.<RepresentationModel[]>} promise of CategoryTypes collection
         */
        _this.getCategoryTypes = function () {
            return rest
                .map(categoryTypeDefinition)
                .willReturn(categoryTypeModel)
                .get();
        };

        /**
         * Get CategoryType by id
         * @param {string|number} id id of the CategoryType
         * @returns {!Promise.<RepresentationModel>} promise of CategoryType
         */
        _this.getCategoryType = function (id) {
            return rest
                .map(categoryTypeDefinition)
                .map(id)
                .willReturn(categoryTypeModel, id)
                .get();
        };

        /**
         * Get CategoryType by code
         * @param {string} code code of the CategoryType
         * @returns {!Promise.<RepresentationModel>} promise of CategoryType
         */
        _this.getCategoryTypeByCode = function (code) {
            return rest
                .map(categoryTypeDefinition)
                .willReturn(categoryTypeModel)
                .get({params: {code: code}});
        };

        /**
         * Get Categories for CategoryType
         * @param {string} id id of the CategoryType
         * @returns {!Promise.<RepresentationModel[]>} promise of Category collection
         */
        _this.getCategoriesForCategoryType = function (id) {
            return rest
                .map(categoryTypeDefinition)
                .map(id)
                .map("categories")
                .willReturn(categoryModel)
                .get();
        };

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var modelUrl = rest.getDefinition("CategoryTypeModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(modelUrl, baserUrl + "/" + modelUrl));
    })

;